import { useEffect, useState } from 'react';
import { measureRtt } from './ping';

/** Best-of-3 HTTP round trip to the server, refreshed every 15 s (shown outside rooms). */
export function useHttpRtt() {
  const [rtt, setRtt] = useState(0);
  useEffect(() => {
    let alive = true;
    const probe = async () => {
      const rtts = await measureRtt();
      if (alive && rtts.length) setRtt(rtts[0]);
    };
    probe();
    const id = setInterval(probe, 15000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);
  return rtt;
}


// ---- remembered throughput ------------------------------------------------------------------
// The player starts at the quality the last session (or speed test) could sustain, instead of
// ramping up from a fixed guess: no blurry first minute on a fast link, no stall on a slow one.
const BW_KEY = 'vb.bw';

export function rememberBandwidth(bps: number) {
  if (!(bps > 100_000)) return;
  try {
    localStorage.setItem(BW_KEY, JSON.stringify({ bps: Math.round(bps), at: Date.now() }));
  } catch {
    /* storage unavailable */
  }
}

export function lastBandwidth(fallback: number): number {
  try {
    const v = JSON.parse(localStorage.getItem(BW_KEY) || 'null') as { bps: number; at: number } | null;
    // Networks change (Wi-Fi → mobile): trust it for a day.
    if (v && Date.now() - v.at < 24 * 3600_000) return v.bps;
  } catch {
    /* ignore */
  }
  return fallback;
}
